import React, { useState, useEffect, createRef } from "react";
import { Container, Row, Col, Stack, Button } from "react-bootstrap";
import Placeholder from 'react-bootstrap/Placeholder';
import Swal from 'sweetalert2'
import { MdModeEdit } from "react-icons/md";
import { MdDelete, MdVisibility } from "react-icons/md";
import { TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_DATEPICKER } from "../../../components/Buttons";
import { BsCloudSlashFill, BsCalendarMinusFill, BsPlusLg } from "react-icons/bs";
import { AuxiliaryService } from "../../../HttpService/AuxiliaryService";
import 'sweetalert2/src/sweetalert2.scss'
import style from "../Users/Users.module.scss";
import styleAdmin from "../Admin.module.scss";
import "../../DataCollection/style.css";
import { MODAL_ROLE } from "../../../components/Modals/ModalForm/ModalRole";
import { OrganizationsService } from "../../../HttpService/OrganizationService";
import { ERoles } from "../../../.config";

const Roles = () => {

    const formRole = createRef();

    const [modalRoleForm, setModalRoleForm] = useState(false)
    const [titleFormRole, setTitleFormRole] = useState("")
    const [responseR, setResponseR] = useState(false)
    const [roles, setRoles] = useState([])
    const [rolesNotFound, setRolesNotFound] = useState(false)
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const getRoles = async() => {
        try {

            let resR = await new OrganizationsService("role/roles/summary").getDataOrganizations();
            if(resR){
                setRoles(prevState => 
                    {                        
                        return  resR.sort(function (x, y) {
                            return x.id - y.id;
                        });
                    });
                setResponseR(true);
            } else {
                setRolesNotFound(true)
            }
            
        } catch (error) {
            console.log("error listing roles", error);
        }
    }

    const detailRole = (id, typeAction) => {
        setModalRoleForm(true)
        formRole.current.detailRole(id, typeAction);
    }
    
    const deleteRole = async (id) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                //showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await new OrganizationsService("role/roles/" + id).deleteUser();
                    if(res.data.success){
                        setRoles((prevState) => {
                            let newState = [...prevState]
                            newState = newState.filter(item => item.id != id)
                            return newState;
                        })
                        Swal.fire(
                        'Deleted!',
                        'The Role has been deleted.',
                        'success'
                        )
                    }else {
                        Swal.fire(
                            'Not Deleted!',
                            'The Role could not be deleted.',
                            'error'
                        );
                    }
                }
            })
        } catch (error) {
            console.log("error in delete Role", error);
        }
    }

    useEffect(() => {
        (async () => {
            await getRoles();
        })();
    }, []);

    return (
            <Container fluid className="todis-form-wrapper p-4">
                <Row className="pb-3 pt-3" style={{overflow: "auto", maxHeight: "780px"}}>
                    <Col lg={6} className="ps-4">
                        <Stack gap={0}>
                            <h4 className="todis-header"><BsCalendarMinusFill className="me-3" />System Roles</h4>
                        </Stack>
                    </Col>
                    <Col lg={6}>
                        <Row className="float-end">
                            <Col lg={12}>
                                <Button variant="outline-primary" onClick={() => {setTitleFormRole("Create"); setModalRoleForm(true);}} className={`${styleAdmin.buttonAdmin} ${"todis-reset-btn float-end"}`} style={{margin: 0, padding: "0.6rem 1.7rem"}}><BsPlusLg className="me-3" size="16"/> CREATE NEW ROLE </Button>
                            </Col>
                        </Row>
                    </Col>
                    {
                        !rolesNotFound && responseR ?
                            (roles.map((role, index) => (<Col lg={12} style={{border: "1px solid #E3F2FD", borderRadius: "20px" ,marginTop: "25px"}} key={"rol-" + index}>
                            <Row style={{padding: "10px"}}>
                                <Col xxl={6} xl={4} lg={12} style={{alignSelf: "center"}}>
                                    <h4 className={style.title}>{ERoles[role.name]? ERoles[role.name].label : role.name}</h4>
                                </Col>
                                <Col xxl={2} xl={2} lg={12}>
                                    <TODIS_BTN_SECUNDARY variant="primary" icon={MdVisibility} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => {setTitleFormRole("Detail"); detailRole(role.id, "view")}}/>
                                </Col>
                                <Col xxl={2} xl={2} lg={12} style={{alignSelf: "center"}}>
                                    { !Object.keys(ERoles).includes(role.name) ? (
                                        <TODIS_BTN_SECUNDARY variant="primary" icon={MdModeEdit} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => {setTitleFormRole("Update"); detailRole(role.id, "update")}}/>
                                    ) : null}
                                </Col>
                                <Col xxl={2} xl={2} lg={12} style={{alignSelf: "center"}}>
                                    { !Object.keys(ERoles).includes(role.name) ? (
                                        <TODIS_BTN_PRIMARY variant="primary" icon={MdDelete} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => deleteRole(role.id)}/>
                                    ) : null}
                                </Col>
                                <Col lg={12} style={{textAlign: "justify", paddingTop: "10px"}}>
                                    <span>
                                        {role.description}
                                    </span>
                                </Col>
                            </Row>
                        </Col>))) : rolesNotFound ?
                                <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                    <h3 className="">Roles Not found </h3>
                                </div></div> :

                                // loading requests 
                                ([...Array(7)].map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                    <Row>
                                        <Col lg={8}>
                                            <Placeholder as="h1" animation="glow"><Placeholder xs={8} size="md" /></Placeholder>
                                        </Col>
                                        <Col lg={4} className="p-0">
                                            <Row>
                                                <Col lg={6}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                                <Col lg={6}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={12}>
                                            <Placeholder as="h4" animation="glow"><Placeholder xs={8} size="md" /></Placeholder>
                                        </Col>
                                    </Row>
                                </Container></Col>)))
                    }
                </Row>
                <MODAL_ROLE ref={formRole} show={modalRoleForm} onHide={() => setModalRoleForm(false)} refreshRoles={getRoles} titleFormRole={titleFormRole}/>
            </Container>
    );
}

export default Roles;